<template>

    <div id="base" class="">

   

      <!-- Unnamed (Rectangle) -->
      <div id="u3005" class="ax_default box_1">
        <div id="u3005_div" class=""></div>
        <div id="u3005_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3006" class="ax_default box_1">
        <div id="u3006_div" class=""></div>
        <div id="u3006_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3007" class="ax_default button" @click="setFlag1(1)">
        <div id="u3007_div" class=""></div>
        <div id="u3007_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3008" class="ax_default button" @click="setFlag1(2)">
        <div id="u3008_div" class=""></div>
        <div id="u3008_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3009" class="ax_default line">
        <img id="u3009_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3009_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3010" class="ax_default button" @click="setFlag1(3)">
        <div id="u3010_div" class=""></div>
        <div id="u3010_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>



      <!-- Unnamed (Group) -->
      <div id="u3012" class="ax_default" data-left="269" data-top="257" data-width="360" data-height="228">

        <!-- Unnamed (Group) -->
        <div id="u3013" class="ax_default" data-left="269" data-top="257" data-width="360" data-height="228">

          <!-- Unnamed (Rectangle) -->
          <div id="u3014" class="ax_default box_1">
            <div id="u3014_div" class=""></div>
            <div id="u3014_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

          <!-- Unnamed (Group) -->
          <div id="u3015" class="ax_default" data-left="301" data-top="268" data-width="299" data-height="150">

            <!-- Unnamed (Rectangle) -->
            <div id="u3016" class="ax_default label">
              <div id="u3016_div" class=""></div>
              <div id="u3016_text" class="text ">
                <p><span>直接排放量（吨二氧化碳）</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3017" class="ax_default label">
              <div id="u3017_div" class=""></div>
              <div id="u3017_text" class="text ">
                <p><span>年度总量</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3018" class="ax_default label">
              <div id="u3018_div" class=""></div>
              <div id="u3018_text" class="text ">
                <p><span>{{carbonLevel1VO.directYear}}</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3019" class="ax_default label">
              <div id="u3019_div" class=""></div>
              <div id="u3019_text" class="text ">
                <p><span>同比变化率</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3020" class="ax_default label">
              <div id="u3020_div" class=""></div>
              <div id="u3020_text" class="text ">
                <p><span>{{carbonLevel1VO.directChangeRateYear}}%</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3021" class="ax_default label">
              <div id="u3021_div" class=""></div>
              <div id="u3021_text" class="text ">
                <p><span>下一年度预测</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3022" class="ax_default label">
              <div id="u3022_div" class=""></div>
              <div id="u3022_text" class="text ">
                <p><span>{{carbonLevel1VO.directForecastYear}}</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3023" class="ax_default label">
              <div id="u3023_div" class=""></div>
              <div id="u3023_text" class="text ">
                <p><span>同比变化量</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3024" class="ax_default label">
              <div id="u3024_div" class=""></div>
              <div id="u3024_text" class="text ">
                <p><span>{{carbonLevel1VO.directChangeYear}}</span></p>
              </div>
            </div>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3025" class="ax_default image" v-if="carbonLevel1VO.directChangeYear>=0">
          <img id="u3025_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u3025_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3026" class="ax_default image" v-if="carbonLevel1VO.directChangeYear>=0">
          <img id="u3026_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u3026_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <!-- Unnamed (Image) -->
        <div id="u3025" class="ax_default image" v-if="carbonLevel1VO.directChangeYear<0">
          <img id="u3025_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u3025_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3026" class="ax_default image" v-if="carbonLevel1VO.directChangeYear<0">
          <img id="u3026_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u3026_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3027" class="ax_default" data-left="648" data-top="257" data-width="360" data-height="228">

        <!-- Unnamed (Group) -->
        <div id="u3028" class="ax_default" data-left="648" data-top="257" data-width="360" data-height="228">

          <!-- Unnamed (Rectangle) -->
          <div id="u3029" class="ax_default box_1">
            <div id="u3029_div" class=""></div>
            <div id="u3029_text" class="text " style="display:none; visibility: hidden">
              <p></p>
            </div>
          </div>

          <!-- Unnamed (Group) -->
          <div id="u3030" class="ax_default" data-left="680" data-top="268" data-width="299" data-height="150">

            <!-- Unnamed (Rectangle) -->
            <div id="u3031" class="ax_default label">
              <div id="u3031_div" class=""></div>
              <div id="u3031_text" class="text ">
                <p><span>间接排放量（吨二氧化碳）</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3032" class="ax_default label">
              <div id="u3032_div" class=""></div>
              <div id="u3032_text" class="text ">
                <p><span>年度总量</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3033" class="ax_default label">
              <div id="u3033_div" class=""></div>
              <div id="u3033_text" class="text ">
                <p><span>{{carbonLevel1VO.indirectYear}}</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3034" class="ax_default label">
              <div id="u3034_div" class=""></div>
              <div id="u3034_text" class="text ">
                <p><span>同比变化率</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3035" class="ax_default label">
              <div id="u3035_div" class=""></div>
              <div id="u3035_text" class="text ">
                <p><span>{{carbonLevel1VO.indirectChangeRateYear}}%</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3036" class="ax_default label">
              <div id="u3036_div" class=""></div>
              <div id="u3036_text" class="text ">
                <p><span>下一年度预测</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3037" class="ax_default label">
              <div id="u3037_div" class=""></div>
              <div id="u3037_text" class="text ">
                <p><span>{{carbonLevel1VO.indirectForecastYear}}</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3038" class="ax_default label">
              <div id="u3038_div" class=""></div>
              <div id="u3038_text" class="text ">
                <p><span>同比变化量</span></p>
              </div>
            </div>

            <!-- Unnamed (Rectangle) -->
            <div id="u3039" class="ax_default label">
              <div id="u3039_div" class=""></div>
              <div id="u3039_text" class="text ">
                <p><span>{{carbonLevel1VO.indirectChangeYear}}</span></p>
              </div>
            </div>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3040" class="ax_default image" v-if="carbonLevel1VO.indirectChangeYear>=0">
          <img id="u3040_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u3040_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3041" class="ax_default image" v-if="carbonLevel1VO.indirectChangeYear>=0">
          <img id="u3041_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u3041_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
           <!-- Unnamed (Image) -->
        <div id="u3040" class="ax_default image" v-if="carbonLevel1VO.indirectChangeYear<0">
          <img id="u3040_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u3040_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3041" class="ax_default image" v-if="carbonLevel1VO.indirectChangeYear<0">
          <img id="u3041_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u3041_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3042" class="ax_default" data-left="254" data-top="553" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u3043" class="ax_default label">
          <div id="u3043_div" class=""></div>
          <div id="u3043_text" class="text ">
            <p><span>排放量详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3044" class="ax_default box_1">
          <div id="u3044_div" class=""></div>
          <div id="u3044_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3045" class="ax_default label">
          <div id="u3045_div" class=""></div>
          <div id="u3045_text" class="text ">
            <p><span>排放类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3046" class="ax_default droplist">
          <div id="u3046_div" class=""></div>
          <select id="u3046_input" class="u3046_input" v-model="queryParams.carbonType">
            <option class="u3046_input_option" selected value="">请选择</option>
            <option class="u3046_input_option" value="1">直接排放</option>
            <option class="u3046_input_option" value="2">间接排放</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3047" class="ax_default label">
          <div id="u3047_div" class=""></div>
          <div id="u3047_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3048" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
                v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                     @change="setDateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
          <div id="u3048_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3049" class="ax_default primary_button"  @click="handleQuery">
          <div id="u3049_div" class=""></div>
          <div id="u3049_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3050" class="ax_default box_1">
          <div id="u3050_div" class=""></div>
          <div id="u3050_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3051" class="ax_default heading_1">
          <div id="u3051_div" class=""></div>
          <div id="u3051_text" class="text ">
            <p><span>排放量</span></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u3052" class="ax_default _水平线">
          <img id="u3052_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u3052_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3053" class="ax_default heading_1">
          <div id="u3053_div" class=""></div>
          <div id="u3053_text" class="text ">
            <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;">时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3054" class="ax_default primary_button">
          <div id="u3054_div" class=""></div>
          <div id="u3054_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3055" class="ax_default label">

<div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
          <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="carbonMonth" />
                <el-table-column label="能耗类型" align="center" prop="carbonType" />
                <el-table-column label="排放量" align="center" prop="useusage" />
             
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>


      <!-- Unnamed (Rectangle) -->
      <div id="u3080" class="ax_default box_1">
        <div id="u3080_div" class=""></div>
        <div id="u3080_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3081" class="ax_default label">
        <div id="u3081_div" class=""></div>
        <div id="u3081_text" class="text ">
          <p><span>总排放量（吨二氧化碳）</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3082" class="ax_default label">
        <div id="u3082_div" class=""></div>
        <div id="u3082_text" class="text ">
          <p><span>{{carbonLevel1VO.totalYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3083" class="ax_default label">
        <div id="u3083_div" class=""></div>
        <div id="u3083_text" class="text ">
          <p><span>同比变化率</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3084" class="ax_default label">
        <div id="u3084_div" class=""></div>
        <div id="u3084_text" class="text ">
          <p><span>{{carbonLevel1VO.totalChangeRateYear}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3085" class="ax_default label">
        <div id="u3085_div" class=""></div>
        <div id="u3085_text" class="text ">
          <p><span>下一年度预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3086" class="ax_default label">
        <div id="u3086_div" class=""></div>
        <div id="u3086_text" class="text ">
          <p><span>{{carbonLevel1VO.totalForecastYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3087" class="ax_default label">
        <div id="u3087_div" class=""></div>
        <div id="u3087_text" class="text ">
          <p><span>同比变化量</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3088" class="ax_default label">
        <div id="u3088_div" class=""></div>
        <div id="u3088_text" class="text ">
          <p><span>{{carbonLevel1VO.totalChangeYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u3089" class="ax_default image" v-if="carbonLevel1VO.totalChangeYear>=0">
        <img id="u3089_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u3089_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u3090" class="ax_default image" v-if="carbonLevel1VO.totalChangeYear>=0">
        <img id="u3090_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u3090_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
         <!-- Unnamed (Image) -->
      <div id="u3089" class="ax_default image" v-if="carbonLevel1VO.totalChangeYear<0">
        <img id="u3089_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u3089_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u3090" class="ax_default image" v-if="carbonLevel1VO.totalChangeYear<0">
        <img id="u3090_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u3090_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
    </div>
    </div>


</template>
<script>
import "echarts/theme/macarons";
import {
  getCarbonLevel1,
  listCarbon,
} from "@/api/business/energy/carbon";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
      components: {Pagination},
  data() {
    return {
        flag:1,
          radio: 1,
         // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      carbonList: [],
      consumptionList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
          queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   carbonType: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      feeTypeList: [
        { itemCode: 1, itemName: "直接排放" },
        { itemCode: 2, itemName: "间接排放" },
      ],

      //-----总碳排放
      monthlyProportionOptions: null,
      seasonProportionOptions: null,
      yearlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsForecast: null,
      seasonProportionOptionsRate: null,
      yearlyProportionOptionsRate: null,
          //----直接碳排放
      powermonthlyProportionOptions: null,
      powerseasonProportionOptions: null,
      poweryearlyProportionOptions: null,
      powermonthlyProportionOptionsRate: null,
      powerseasonProportionOptionsRate: null,
      poweryearlyProportionOptionsRate: null,
      //----间接碳排放
      gasmonthlyProportionOptions: null,
      gasseasonProportionOptions: null,
      gasyearlyProportionOptions: null,
      gasmonthlyProportionOptionsRate: null,
      gasseasonProportionOptionsRate: null,
      gasyearlyProportionOptionsRate: null,
  
     //接收统计数据的对象
       carbonLevel1VO: {
         //----------汇总数据-------------
            //今年总量

            totalYear: "",
            directYear: "",
            indirectYear: "",



            //---今年用量变化
            directChangeYear: "",
            totalChangeYear: "",
            indirectChangeYear: "",


            //---今年用量变化率
            directChangeRateYear: "",
            totalChangeRateYear: "",
            indirectChangeRateYear: "",


            //--下一周期预测
            directForecastYear: "",
            totalForecastYear: "",
            indirectForecastYear: "",


            //----------------直接-----------------------------
            //季总量
            directSeason1: "",
            directSeason2: "",
            directSeason3: "",
            directSeason4: "",

            //---季度用量变化
            directChangeSeason1: "",
            directChangeSeason2: "",
            directChangeSeason3: "",
            directChangeSeason4: "",

            //---季用量变化率
            directChangeRateSeason1: "",
            directChangeRateSeason2: "",
            directChangeRateSeason3: "",
            directChangeRateSeason4: "",

            //--季下一周期预测
            directForecastSeason1: "",
            directForecastSeason2: "",
            directForecastSeason3: "",
            directForecastSeason4: "",


            //---------------总----------------------------------------

            //总量
            totalSeason1: "",
            totalSeason2: "",
            totalSeason3: "",
            totalSeason4: "",
            //---季度用量变化
            totalChangeSeason1: "",
            totalChangeSeason2: "",
            totalChangeSeason3: "",
            totalChangeSeason4: "",

            //---季用量变化率
            totalChangeRateSeason1: "",
            totalChangeRateSeason2: "",
            totalChangeRateSeason3: "",
            totalChangeRateSeason4: "",

            //--季下一周期预测
            totalForecastSeason1: "",
            totalForecastSeason2: "",
            totalForecastSeason3: "",
            totalForecastSeason4: "",

            //--------------间接-------------------------------------
            //季总量
            indirectSeason1: "",
            indirectSeason2: "",
            indirectSeason3: "",
            indirectSeason4: "",
            //---季度用量变化
            indirectChangeSeason1: "",
            indirectChangeSeason2: "",
            indirectChangeSeason3: "",
            indirectChangeSeason4: "",
            //---季用量变化率
            indirectChangeRateSeason1: "",
            indirectChangeRateSeason2: "",
            indirectChangeRateSeason3: "",
            indirectChangeRateSeason4: "",

            //--季下一周期预测
            indirectForecastSeason1: "",
            indirectForecastSeason2: "",
            indirectForecastSeason3: "",
            indirectForecastSeason4: "",


            //-------------直接----------------------------
            //月总量
            directMonth1: "",
            directMonth2: "",
            directMonth3: "",
            directMonth4: "",
            directMonth5: "",
            directMonth6: "",
            directMonth7: "",
            directMonth8: "",
            directMonth9: "",
            directMonth10: "",
            directMonth11: "",
            directMonth12: "",

            //月变化
            directChangeMonth1: "",
            directChangeMonth2: "",
            directChangeMonth3: "",
            directChangeMonth4: "",
            directChangeMonth5: "",
            directChangeMonth6: "",
            directChangeMonth7: "",
            directChangeMonth8: "",
            directChangeMonth9: "",
            directChangeMonth10: "",
            directChangeMonth11: "",
            directChangeMonth12: "",
            //---月变化率
            directChangeRateMonth1: "",
            directChangeRateMonth2: "",
            directChangeRateMonth3: "",
            directChangeRateMonth4: "",
            directChangeRateMonth5: "",
            directChangeRateMonth6: "",
            directChangeRateMonth7: "",
            directChangeRateMonth8: "",
            directChangeRateMonth9: "",
            directChangeRateMonth10: "",
            directChangeRateMonth11: "",
            directChangeRateMonth12: "",


            //--月下一周期预测
            directForecastMonth1: "",
            directForecastMonth2: "",
            directForecastMonth3: "",
            directForecastMonth4: "",
            directForecastMonth5: "",
            directForecastMonth6: "",
            directForecastMonth7: "",
            directForecastMonth8: "",
            directForecastMonth9: "",
            directForecastMonth10: "",
            directForecastMonth11: "",
            directForecastMonth12: "",
            //--------------------
            //总量
            totalMonth1: "",
            totalMonth2: "",
            totalMonth3: "",
            totalMonth4: "",
            totalMonth5: "",
            totalMonth6: "",
            totalMonth7: "",
            totalMonth8: "",
            totalMonth9: "",
            totalMonth10: "",
            totalMonth11: "",
            totalMonth12: "",
            //月变化
            totalChangeMonth1: "",
            totalChangeMonth2: "",
            totalChangeMonth3: "",
            totalChangeMonth4: "",
            totalChangeMonth5: "",
            totalChangeMonth6: "",
            totalChangeMonth7: "",
            totalChangeMonth8: "",
            totalChangeMonth9: "",
            totalChangeMonth10: "",
            totalChangeMonth11: "",
            totalChangeMonth12: "",
            //---月变化率
            totalChangeRateMonth1: "",
            totalChangeRateMonth2: "",
            totalChangeRateMonth3: "",
            totalChangeRateMonth4: "",
            totalChangeRateMonth5: "",
            totalChangeRateMonth6: "",
            totalChangeRateMonth7: "",
            totalChangeRateMonth8: "",
            totalChangeRateMonth9: "",
            totalChangeRateMonth10: "",
            totalChangeRateMonth11: "",
            totalChangeRateMonth12: "",


            //--月下一周期预测
            totalForecastMonth1: "",
            totalForecastMonth2: "",
            totalForecastMonth3: "",
            totalForecastMonth4: "",
            totalForecastMonth5: "",
            totalForecastMonth6: "",
            totalForecastMonth7: "",
            totalForecastMonth8: "",
            totalForecastMonth9: "",
            totalForecastMonth10: "",
            totalForecastMonth11: "",
            totalForecastMonth12: "",
            //间接
            indirectMonth1: "",
            indirectMonth2: "",
            indirectMonth3: "",
            indirectMonth4: "",
            indirectMonth5: "",
            indirectMonth6: "",
            indirectMonth7: "",
            indirectMonth8: "",
            indirectMonth9: "",
            indirectMonth10: "",
            indirectMonth11: "",
            indirectMonth12: "",
            //月变化
            indirectChangeMonth1: "",
            indirectChangeMonth2: "",
            indirectChangeMonth3: "",
            indirectChangeMonth4: "",
            indirectChangeMonth5: "",
            indirectChangeMonth6: "",
            indirectChangeMonth7: "",
            indirectChangeMonth8: "",
            indirectChangeMonth9: "",
            indirectChangeMonth10: "",
            indirectChangeMonth11: "",
            indirectChangeMonth12: "",
            //---变化率
            indirectChangeRateMonth1: "",
            indirectChangeRateMonth2: "",
            indirectChangeRateMonth3: "",
            indirectChangeRateMonth4: "",
            indirectChangeRateMonth5: "",
            indirectChangeRateMonth6: "",
            indirectChangeRateMonth7: "",
            indirectChangeRateMonth8: "",
            indirectChangeRateMonth9: "",
            indirectChangeRateMonth10: "",
            indirectChangeRateMonth11: "",
            indirectChangeRateMonth12: "",

            //--下一周期预测
            indirectForecastMonth1: "",
            indirectForecastMonth2: "",
            indirectForecastMonth3: "",
            indirectForecastMonth4: "",
            indirectForecastMonth5: "",
            indirectForecastMonth6: "",
            indirectForecastMonth7: "",
            indirectForecastMonth8: "",
            indirectForecastMonth9: "",
            indirectForecastMonth10: "",
            indirectForecastMonth11: "",
            indirectForecastMonth12: "",
        },


    };
  },
  created() {
  getCarbonLevel1(this.queryParams).then((response) => {
    // alert("11111");
        this.carbonLevel1VO = response.data;
       // alert("22222");
        //alert("totalYear=="+this.carbonLevel1VO.totalYear);
       // alert("change=="+this.carbonLevel1VO.totalChangeYear);
        //alert("changerate=="+this.carbonLevel1VO.totalChangeRateYear);
       // alert("forecast=="+this.carbonLevel1VO.totalForecastYear);
        //--------变化量
         // this.monthlyProportionOptions = this.monthlyProportion();
        // this.seasonProportionOptionsRate=this.seasonProportionRate(1);
        // this.seasonProportionOptionsForecast = this.seasonProportionForecast(1);
                });
    
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
        // alert("child="+iflag);

     },
                      /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
         /** 查询列表 */
    getList() {
      this.loading = true;

      listCarbon(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
         
            if(response.rows[i].carbonType==2){
              response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='直接碳排放';}
              if(response.rows[i].carbonType==3){
               response.rows[i].carbonMonth=response.rows[i].carbonYear+'-'+response.rows[i].carbonMonth;
              
               response.rows[i].carbonType='间接碳排放';}
            
            
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
   }
}
</script>
<style src = "../../../../../../assets/common/carbon/css/year/styles.css" scope></style>
<style src = "../../../../../../assets/common/consumption/css/styles.css" scope></style>
<style src = "../../../../../../assets/common/rp_page.css" scope></style>
<style scoped>
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
   .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>